import * as React from 'react';
import { FC } from 'react';
import { v4 as uuidv4 } from "uuid";

interface RecipePageStarRatingStaticStarModel {
    starValue: number,
    starIndex: number,
}

const RecipePageStarRatingStaticStar: FC<RecipePageStarRatingStaticStarModel> = (props) => {

    const [offset, setOffset] = React.useState(0);
    const id = uuidv4();

    const calculateOffset = () => {
        if ( props.starValue >= props.starIndex + 1) {
            setOffset(1);
        }
        else if (props.starValue > props.starIndex) {
            setOffset(props.starValue - Math.floor(props.starValue));
        }
    }    

    React.useEffect(() => {
        calculateOffset();
    }, []);

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25" fill="none" className='w-6 h-6 laptop:w-5 laptop:h-5'>
            <mask id={`mask0_721_36802${id}`} maskUnits="userSpaceOnUse" x="0" y="0">
                <rect y="0.786682" width="24" height="24" fill="#D9D9D9"/>
            </mask>
            <g mask={`url(#mask0_721_36802${id})`}>
                <path d="M5.825 21.7867L7.45 14.7617L2 10.0367L9.2 9.41168L12 2.78668L14.8 9.41168L22 10.0367L16.55 14.7617L18.175 21.7867L12 18.0617L5.825 21.7867Z" fill={`url(#paint0_linear_721_36802${id})`} />
            </g>
            <defs>
                <linearGradient id={`paint0_linear_721_36802${id}`} x1="2" y1="12.2867" x2="22" y2="12.2867" gradientUnits="userSpaceOnUse">
                    <stop offset={offset} stopColor="#F79B1A"/>
                    <stop offset={offset} stopColor="#EADFCC"/>
                </linearGradient>
            </defs>
        </svg>
    );
};
export default RecipePageStarRatingStaticStar;